import { render, staticRenderFns } from "./ImagePreviewPopup.vue?vue&type=template&id=6b46eaf1&scoped=true"
import script from "./ImagePreviewPopup.vue?vue&type=script&lang=js"
export * from "./ImagePreviewPopup.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewPopup.vue?vue&type=style&index=0&id=6b46eaf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46eaf1",
  null
  
)

export default component.exports